import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LocationModel } from 'client/data/models/location';
import { isDealerOpen } from './dealer-details-work-hours-helper';

export function DealerWorkTimeStatusUI({ className, dealerLocation, workHours, currentDay }) {
  if (isEmpty(dealerLocation)) return null;

  const isOpenNow = isDealerOpen(dealerLocation, workHours, currentDay);
  return (
    <span className={classNames('dealer-work-time-status fw-bold', className)}>
      {isOpenNow ? <span className="text-green-40">Open now</span> : <span className="text-danger">Closed now</span>}
    </span>
  );
}

DealerWorkTimeStatusUI.propTypes = {
  dealerLocation: PropTypes.shape({
    gmtOffset: PropTypes.number,
    dst: PropTypes.string,
  }),
  workHours: DealerInfoEntities.WorkHours.isRequired,
  currentDay: PropTypes.string,
  className: PropTypes.string,
};

DealerWorkTimeStatusUI.defaultProps = {
  currentDay: '',
  className: '',
  dealerLocation: null,
};

const stateToPropsConfig = {
  dealerLocation: bindToPath(({ dealerZip }) => !!dealerZip && `zips["${dealerZip}"]`, LocationModel),
};

export const DealerWorkTimeStatus = connectToModel(DealerWorkTimeStatusUI, stateToPropsConfig);

DealerWorkTimeStatus.propTypes = {
  ...DealerWorkTimeStatusUI.propTypes,
  dealerZip: PropTypes.string,
};

DealerWorkTimeStatus.defaultProps = {
  ...DealerWorkTimeStatusUI.defaultProps,
  dealerZip: null,
};
